// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","submit":"styles_submit__gA-Tb","form":"styles_form__1OOC+","title":"styles_title__Pkqjv"};